/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import { store } from 'react-notifications-component';
import Tour from 'reactour';
import { Trans } from 'react-i18next';

import LayoutSimple from '../components/LayoutSimple.jsx';
import NavigatorSimple from '../components/NavigatorSimple.jsx';
import MapPreview from '../components/MapPreview.jsx';
import LoadingModal from '../components/LoadingModal';

import { postRequest, simpleGetRequest, downloadRequestGET} from '../service/ApiService';
import LocalStorage from '../service/LocalStorage';

import {createTheme} from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {ThemeProvider} from '@material-ui/styles';

import {properties} from '../resources/properties.js';
import i18n from '../resources/i18n';

//FOR FRONT MAP
import LOGO from '../img/Comunes/Logo_img01.png';//'../img/Comunes/img01.png'; //logo portada bot
import LOGO_MAC_N from '../img/Comunes/img02.png'; //logo MAC top
import LOGO_MAC_S_M from '../img/Comunes/img02_special_map.png'; //Logo MAC Especial MTN
import LOGO_MAC_S_I from '../img/Comunes/img02_special_img.png'; //Logo MAC Especial IMAGE
import DEGRADADO from '../img/Comunes/degradado.png'; //logo MAC top

import E20K from '../img/escalas/E20k.png';
import E25K from '../img/escalas/E25k.png';
import E30K from '../img/escalas/E30k.png';
import E40K from '../img/escalas/E40k.png';
import E50K from '../img/escalas/E50k.png';
import E60K from '../img/escalas/E60k.png';

import E20K_M from '../img/escalas/E20k_m.png';
import E25K_M from '../img/escalas/E25k_m.png';
import E30K_M from '../img/escalas/E30k_m.png';
import E40K_M from '../img/escalas/E40k_m.png';
import E50K_M from '../img/escalas/E50k_m.png';
import E60K_M from '../img/escalas/E60k_m.png';

import ESQM34 from '../img/esquemas/img34.png';
import ESQM35 from '../img/esquemas/img35.png';
import ESQM36 from '../img/esquemas/img36.png';
import ESQM37 from '../img/esquemas/img37.png';
import ESQM38 from '../img/esquemas/img38.png';
import ESQM39 from '../img/esquemas/img39.png';

import L1_L from '../img/leyendas/img12.png';
import L2_L from '../img/leyendas/img13.png';
import L3_L from '../img/leyendas/img14.png';
import L4_L from '../img/leyendas/img15.png';
import L5_L from '../img/leyendas/img16.png';
import L1_H from '../img/leyendas/img17.png';
import L2_H from '../img/leyendas/img18.png';
import L3_H from '../img/leyendas/img19.png';
import L4_H from '../img/leyendas/img20.png';
import L5_H from '../img/leyendas/img21.png';

import ESPANIA from '../img/E05_mapa_ubicacion.png';
import CIRCLE4 from '../img/img04.png';
import CIRCLE5 from '../img/img05.png';
import CIRCLE6 from '../img/img06.png';
import CIRCLE7 from '../img/img07.png';
import QRIMAGE from '../img/qrcode.png';
import TITLETOP from '../img/titulo_contraportada.png';
import TITLEQR from '../img/titulo_QR.png';

declare var M;
const pluginListPreview = [new M.plugin.Mapaalacarta({enabled: false})];

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

let API_URL = properties.apiURLApiService;
if (window.location.protocol === 'https:' && API_URL.includes('http://'))
  API_URL = API_URL.replace('http://', 'https://');
else if (window.location.protocol === 'http:' && API_URL.includes('https://'))
  API_URL = API_URL.replace('https://', 'http://');

class Step2S extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfCopies: "1",
      paperType: "Normalsinplegar", // Normalplegado
      totalPrice: '',
      isLoaded: true,
      urlPDF: undefined,
      showModal: false,
      showModalDownload: false,
      showModalCart: false,
      showModalRedirect: false,
      condiciones: false,
      showSnackbar: false,
      showSnackbarTypeURL: true,
      petition: 'PDF',
      isTourOpen: false,
      includeLinearProgress: true,
    };
    this.previuslyAddedToCart = {};
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseDownload = this.handleCloseDownload.bind(this);
    this.handleOpenCart = this.handleOpenCart.bind(this);
    this.handleCloseCart = this.handleCloseCart.bind(this);
    this.handleOpenRedirect = this.handleOpenRedirect.bind(this);
    this.handleCloseRedirect = this.handleCloseRedirect.bind(this);
    this.doPriceRequest(this.state.paperType, this.state.numberOfCopies);
    //Logos WEB apropiados segun Mapa Especial
    if(this.props.parentState.specialMapGeneration){
      if(props.parentState.seleccionadoProductoSeries === 'Foto'){
        this.LOGO_MAC = LOGO_MAC_S_I;
      }else{
        this.LOGO_MAC = LOGO_MAC_S_M;
      }
    } else {
      this.LOGO_MAC = LOGO_MAC_N;
    }
  }

  functionUpdatePrice = (event) => {
    let paperType, totalPrice;
    switch (event.target.name) {
      case "Normal":
        if (this.state.paperType.includes('plegado')) {
          paperType = 'Normalplegado';
        } else {
          paperType = 'Normalsinplegar';
        }
        break;
      case "Aventura":
        if (this.state.paperType.includes('plegado')) {
          paperType = 'Aventuraplegado';
        } else {
          paperType = 'Aventurasinplegar';
        }
        break;
      case "Plegado":
        if (this.state.paperType.includes('Aventura')) {
          paperType = 'Aventuraplegado';
        } else {
          paperType = 'Normalplegado';
        }
        break;
      case "Enrollado":
        if (this.state.paperType.includes('Aventura')) {
          paperType = 'Aventurasinplegar';
        } else {
          paperType = 'Normalsinplegar';
        }
        break
      default:
        paperType = 'Normalplegado'
        break;

    }
    totalPrice = this.doPriceRequest(paperType, this.state.numberOfCopies);
  }

  functionUpdateCopies = (event) => {
    let copies = event.target.value;
    let totalPrice = Math.round((parseFloat(this.state.totalPrice) / parseFloat(this.state.numberOfCopies)) * parseFloat(copies) * 100) / 100;
    this.setState({numberOfCopies: copies, totalPrice: totalPrice});

  }

  setStateGlobal = (parentState) => {
    const {setParentState} = this.props;

    setParentState(parentState);
  }
  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  getIdMAC = () => { // genera el ID del PDF (fecha + random + tipo producto)
    const dateParts = new Intl.DateTimeFormat("es-ES", {
      timeZone: "Europe/Madrid",
      year: "2-digit",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(new Date());

    const yy = dateParts.find(p => p.type === "year").value;
    const mm = dateParts.find(p => p.type === "month").value;
    const dd = dateParts.find(p => p.type === "day").value;

    return yy
      + mm
      + dd + "-"
      + Math.floor(Math.random() * 1000000000).toString().padStart(9, "0")
      + "-M"; 
  }

  closeTour = () => {
    this.setState({isTourOpen: false});
  }

  openTour = () => {
    this.setState({isTourOpen: true});
  }

  auxiliarMareografo(parentState) {
    if (parentState.mathsDataCenter){
      let mareografo;
      if (parentState.mathsDataCenter[1] !== "undefined") {
        if (parentState.mathsDataCenter[1].includes('Oeste')) {
          if (parentState.mathsDataCenter[3].includes("-")) {
            mareografo = parentState.ruteServerImagenesEsquemas + "img35";
          } else {
            mareografo = parentState.ruteServerImagenesEsquemas + "img38";
          }
        } else {
          if (parentState.mathsDataCenter[3].includes("-")) {
            mareografo = parentState.ruteServerImagenesEsquemas + "img34";
          } else {
            mareografo = parentState.ruteServerImagenesEsquemas + "img37";
          }
        }
      } else {
        if (parentState.mathsDataCenter[3].includes("-")) {
          mareografo = parentState.ruteServerImagenesEsquemas + "img36";
        } else {
          mareografo = parentState.ruteServerImagenesEsquemas + "img39";
        }
      }
  
      if(parentState.orientation === "Retrato"){
        mareografo += "_R";
      }
  
      mareografo += ".png";
  
      return mareografo;
    } else {
      console.warn("mathsDataCenter not obtained")
      return parentState.ruteServerImagenesEsquemas + "img36" + (parentState.orientation === "Retrato" ? "_R.png" : ".png");
    }
  }

  doPriceRequest(tipoDePapel, cantidad) {
    const allTypes = properties.TIPOS_DE_PAPEL_COMPRA;
    let url = '/conectorMAC/getPrices?';
    url += tipoDePapel + '=' + cantidad;
    allTypes.filter((x) => x !== tipoDePapel).forEach((tipo) => {
      url += '&' + tipo + '=0';
    });

    simpleGetRequest(url).then(response => {
      let responseData = JSON.parse(JSON.stringify(response.data));
      this.setState({paperType: tipoDePapel, totalPrice: responseData.totalsiniva});
    }).catch(() => console.warn('ERROR price request'));
  }

  handleClose() {
    this.setState({showModal: false});
  }

  handleShow() {
    this.setState({showModal: true});
  }

  handleCloseDownload() {
    this.setState({showModalDownload: false});
  }

  handleOpenCart() {
    this.setState({showModalCart: true});
  }
  handleCloseCart() {
    this.setState({showModalCart: false});
  }
  handleOpenRedirect() {
    this.setState({showModalRedirect: true});
  }
  handleCloseRedirect() {
    this.setState({showModalRedirect: false});
  }

  async doRequest(parentState, conversorPDF) {
    if (this.state.urlPDF !== undefined) {
      this.setState({petition: 'PDF', includeLinearProgress: true, showModalDownload: true, showModal: false, isLoaded: true});
    } else {
      await parentState.mathsDataCenter;
      const headers = {};
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.idPedido = id;
      if (parentState.mathsDataCenter){
        conversorPDF.attributes.mathsDataCenter = parentState.mathsDataCenter[0];
      } else {
        conversorPDF.attributes.mathsDataCenter = "";
      }
      conversorPDF.attributes.mareografo = this.auxiliarMareografo(parentState);
      if (conversorPDF.attributes.mareografo.endsWith && (conversorPDF.attributes.mareografo.endsWith("img39.png") || conversorPDF.attributes.mareografo.endsWith("img36.png") || conversorPDF.attributes.mareografo.endsWith("img39_R.png") || conversorPDF.attributes.mareografo.endsWith("img36_R.png"))) {
        conversorPDF.attributes.delta = parentState.ruteServerImagenesComunes + "img199.png";
      }
      this.setState({petition: 'PDF', includeLinearProgress: true, showModal: false, isLoaded: false, text: this.loaderAltaRes});
      headers["Content-Type"] = "application/json";
      headers["Access-Control-Allow-Origin"] = "*";
      let urlPDF;
      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        //conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0] + ' - ' + id;
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0];
      }

      postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
        clearInterval(window.timer);
        if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
          this.savedAt = new Date().getTime();
          urlPDF = '/conectorMAC/getPDFByID?printID=' + id;
          this.setState({
            petition: 'PDF',
            showModalDownload: true,
            idPedido: id,
            isLoaded: true,
            urlPDF: API_URL + urlPDF
          });
        } else {
          const component = <div className='notification-content notification-info'>
            <div className='notification-close'></div>
            <p className='notification-message'>
              <span>
                {i18n.t('step2.error_pdf_1')}.<br/>
              {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
                {i18n.t('step2.error_pdf_3')}: {id}<br/>
              </span>
              <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
            </p>
          </div>;

          this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
          store.addNotification({
            id: 'print-notification',
            type: 'danger',
            insert: 'top',
            content: component,
            container: 'center',
            animationIn: ['animated', 'fadeIn'],
            dismiss: {
              duration: 0,
              click: false,
              touch: false,
            },
          });

          this.addCloseNotificationEvent();
        }
      }).catch(err => {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              <br/>
              {i18n.t('step2.error_pdf_1')}.<br/>
              <br/>
            </span>
          </p>
        </div>;

        clearInterval(window.timer);
        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
      });
    }
  }

  addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items){
    if(!searchItem){//CHECK if duplicate //Si ya existe en carrito este mismo apartado, pues no se añade antes de la redirreción
      const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
      const item = {
        type: tipoImpresion,
        quantity: cantidad,
        url: urlPDF,
        title: this.props.parentState.title,
        subtitle: this.props.parentState.subtitle,
        id: urlPDF.split('?printID=')[1],
        price: price,
        savedAt: this.savedAt,
      };
      items.push(item);
      LocalStorage.put('mac-items', items);
    }
    window.location.href = '/mapaalacarta/ShoppingCart';
  }

  async tiendaVirtual(estado) {
    const tipoImpresion = estado.paperType;
    const cantidad = estado.numberOfCopies;
    let urlPDF;
    this.setState({petition: 'PDF', isLoaded: false, text: this.loaderAltaRes});
    if (estado.urlPDF !== undefined) {
      urlPDF = estado.urlPDF;
      const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];//Check group buy
      if(items.length === 0){//Send to store
        simpleGetRequest('/conectorMAC/urlCompra?tipoImpresion=' + tipoImpresion + '&cantidad=' + cantidad + '&urlPDF=' + urlPDF).then(response => {
          let responseData = JSON.parse(JSON.stringify(response.data));
          window.open(responseData.url, "_self");
          this.setState({petition: 'PDF', includeLinearProgress: true, isLoaded: true, urlPDF: urlPDF});
        });
      } else {//Send to cart
        const searchItem = items.find(item=>{return item.type === tipoImpresion && item.url === urlPDF && item.title === this.props.parentState.title && item.subtitle === this.props.parentState.subtitle})
        this.addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items);
      }
    } else {
      const headers = {};
      headers["Content-Type"] = "application/json";
      headers["Access-Control-Allow-Origin"] = "*";
      const conversorPDF = this.props.conversorPDF;
      const parentState = this.props.parentState;
      await parentState.mathsDataCenter;
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.idPedido = id;
      if (parentState.mathsDataCenter){
        conversorPDF.attributes.mathsDataCenter = parentState.mathsDataCenter[0];
      } else {
        conversorPDF.attributes.mathsDataCenter = "";
      }
      conversorPDF.attributes.mareografo = this.auxiliarMareografo(parentState);
      if (conversorPDF.attributes.mareografo.endsWith && (conversorPDF.attributes.mareografo.endsWith("img39.png") || conversorPDF.attributes.mareografo.endsWith("img36.png") || conversorPDF.attributes.mareografo.endsWith("img39_R.png") || conversorPDF.attributes.mareografo.endsWith("img36_R.png"))) {
        conversorPDF.attributes.delta = parentState.ruteServerImagenesComunes + "img199.png";
      }

      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        //conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0] + ' - ' + id;
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0];
      }

      postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
        if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
          this.savedAt = new Date().getTime();
          urlPDF = API_URL + '/conectorMAC/getPDFByID?printID=' + id;
          const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];//Check group buy
          if(items.length === 0){//Send to store
            simpleGetRequest('/conectorMAC/urlCompra?tipoImpresion=' + tipoImpresion + '&cantidad=' + cantidad + '&urlPDF=' + urlPDF).then(response => {
              let responseData = JSON.parse(JSON.stringify(response.data));
              window.open(responseData.url, "_self");
              if (!urlPDF.includes(API_URL)) {
                urlPDF = API_URL + urlPDF;
              }
              this.setState({petition: 'PDF', isLoaded: true, urlPDF: urlPDF, idPedido: id});
            });
          } else {//Send to cart
            const searchItem = items.find(item=>{return item.type === tipoImpresion && item.url === urlPDF && item.title === this.props.parentState.title && item.subtitle === this.props.parentState.subtitle})
            this.addAndRedirectToCart(searchItem, tipoImpresion, cantidad, urlPDF, items);
          }
        } else {
          const component = <div className='notification-content notification-info'>
            <div className='notification-close'></div>
            <p className='notification-message'>
              <span>
                {i18n.t('step2.error_pdf_1')}.<br/>
              {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
                {i18n.t('step2.error_pdf_3')}: {id}<br/>
              </span>
              <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
            </p>
          </div>;

          this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
          store.addNotification({
            id: 'print-notification',
            type: 'danger',
            insert: 'top',
            content: component,
            container: 'center',
            animationIn: ['animated', 'fadeIn'],
            dismiss: {
              duration: 0,
              click: false,
              touch: false,
            },
          });

          this.addCloseNotificationEvent();
        }
      }).catch(err => {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              <br/>
              {i18n.t('step2.error_pdf_1')}.<br/>
              <br/>
            </span>
          </p>
        </div>;

        clearInterval(window.timer);
        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
      });
    }
  }

  async addToShoppingCart(estado) {
    this.previuslyAddedToCart[this.state.paperType] = true;
    const tipoImpresion = estado.paperType;
    const cantidad = estado.numberOfCopies;
    let urlPDF;
    if (estado.urlPDF !== undefined) {
      urlPDF = estado.urlPDF;
      const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
      const item = {
        type: tipoImpresion,
        quantity: cantidad,
        url: urlPDF,
        title: this.props.parentState.title,
        subtitle: this.props.parentState.subtitle,
        id: urlPDF.split('?printID=')[1],
        price: price,
        savedAt: this.savedAt,
      };

      const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];
      if(items.length > 0){
        const findSimilarItem = items.find(i=>i.type === item.type && i.id === item.id && i.subtitle === item.subtitle);
        if(findSimilarItem){
          findSimilarItem.quantity = (Number.parseInt(findSimilarItem.quantity) + Number.parseInt(item.quantity)).toFixed();
        }else{
          items.push(item);
        }
      }else{
        items.push(item);
      }
      LocalStorage.put('mac-items', items);
      this.props.parentState.callback();
      this.handleOpenRedirect();
    } else {
      this.setState({petition: 'PDF', isLoaded: false, includeLinearProgress: true, text: this.loaderAltaRes});
      const headers = {};
      headers["Content-Type"] = "application/json";
      headers["Access-Control-Allow-Origin"] = "*";
      const conversorPDF = this.props.conversorPDF;
      const parentState = this.props.parentState;
      await parentState.mathsDataCenter;
      let id = this.getIdMAC();//this.state.paperType, this.state.numberOfCopies
      conversorPDF.attributes.idPedido = id;
      if (parentState.mathsDataCenter){
        conversorPDF.attributes.mathsDataCenter = parentState.mathsDataCenter[0];
      } else {
        conversorPDF.attributes.mathsDataCenter = "";
      }
      conversorPDF.attributes.mareografo = this.auxiliarMareografo(parentState);
      if (conversorPDF.attributes.mareografo.endsWith && (conversorPDF.attributes.mareografo.endsWith("img39.png") || conversorPDF.attributes.mareografo.endsWith("img36.png") || conversorPDF.attributes.mareografo.endsWith("img39_R.png") || conversorPDF.attributes.mareografo.endsWith("img36_R.png"))) {
        conversorPDF.attributes.delta = parentState.ruteServerImagenesComunes + "img199.png";
      }

      if (conversorPDF.attributes.agradecimientos !== undefined && conversorPDF.attributes.agradecimientos.length > 2) {
        conversorPDF.attributes.agradecimientos = conversorPDF.attributes.agradecimientos.split(' - ')[0];
      }

      postRequest('/conectorMAC/PrintPDF?printID=' + id, conversorPDF, headers).then(response => {
        if (typeof response.data === 'string' && response.data.indexOf('error') === -1) {
          this.savedAt = new Date().getTime();
          urlPDF = API_URL + '/conectorMAC/getPDFByID?printID=' + id;
          const price = parseFloat(document.querySelector('.price div > label').innerText.trim()) / cantidad;
          const item = {
            type: tipoImpresion,
            quantity: cantidad,
            url: urlPDF,
            title: parentState.title,
            subtitle: parentState.subtitle,
            id: id,
            price: price,
            savedAt: this.savedAt,
          };

          const items = LocalStorage.get('mac-items') !== undefined ? LocalStorage.get('mac-items') : [];
          if(items.length > 0){
            const findSimilarItem = items.find(i=>i.type === item.type && i.id === item.id && i.subtitle === item.subtitle);
            if(findSimilarItem){
              findSimilarItem.quantity = (Number.parseInt(findSimilarItem.quantity) + Number.parseInt(item.quantity)).toFixed();
            }else{
              items.push(item);
            }
          }else{
            items.push(item);
          }
          LocalStorage.put('mac-items', items);
          this.setState({ petition: 'PDF', isLoaded: true, urlPDF: urlPDF, idPedido: id }, () => {
            this.props.parentState.callback();
          });
          this.handleOpenRedirect();
        } else {
          const component = <div className='notification-content notification-info'>
            <div className='notification-close'></div>
            <p className='notification-message'>
              <span>
                {i18n.t('step2.error_pdf_1')}.<br/>
              {i18n.t('step2.error_pdf_2')}: {response.data.message}<br/>
                {i18n.t('step2.error_pdf_3')}: {id}<br/>
              </span>
              <span dangerouslySetInnerHTML={{__html: i18n.t('step2.error_pdf_4')}} />
            </p>
          </div>;

          this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
          store.addNotification({
            id: 'print-notification',
            type: 'danger',
            insert: 'top',
            content: component,
            container: 'center',
            animationIn: ['animated', 'fadeIn'],
            dismiss: {
              duration: 0,
              click: false,
              touch: false,
            },
          });

          this.addCloseNotificationEvent();
          this.previuslyAddedToCart[this.state.paperType] = false;
        }
      }).catch(err => {
        const component = <div className='notification-content notification-info'>
          <div className='notification-close'></div>
          <p className='notification-message'>
            <span>
              <br/>
              {i18n.t('step2.error_pdf_1')}.<br/>
              <br/>
            </span>
          </p>
        </div>;

        clearInterval(window.timer);
        this.setState({ petition: 'PDF', isLoaded: true, includeLinearProgress: false, text: i18n.t('step2.error_pdf_1') });
        store.addNotification({
          id: 'print-notification',
          type: 'danger',
          insert: 'top',
          content: component,
          container: 'center',
          animationIn: ['animated', 'fadeIn'],
          dismiss: {
            duration: 0,
            click: false,
            touch: false,
          },
        });

        this.addCloseNotificationEvent();
        this.previuslyAddedToCart[this.state.paperType] = false;
      });
    }
  }

  componentWillUnmount(){
    if(this.notificationListenerFunction){
      let auxNotif = document.querySelector('.notification-close');
      if(auxNotif) auxNotif.removeEventListener('click', this.notificationListenerFunction);
    }
  }

  addCloseNotificationEvent = () => {
    setTimeout(() => {
      this.notificationListenerFunction = () => {store.removeNotification('print-notification');};
      document.querySelector('.notification-close').addEventListener('click', this.notificationListenerFunction);
    }, 100);
  }

  handleCloseSnackbar() {
    this.setState({showSnackbar: false});
  }

  handleShowSnackbar(type) {
    this.setState({showSnackbar: true, showSnackbarTypeURL: type});
  }
  downloadPDF(urlPDF, id) {
    const headers = {};
    headers["Content-Type"] = "application/json";
    headers["Access-Control-Allow-Origin"] = "*";
    if (!urlPDF.includes(API_URL)) {urlPDF = API_URL + urlPDF;}
    this.setState({showModalDownload: false, showModal: false, includeLinearProgress: false, isLoaded: false, text: this.loaderWait});
    downloadRequestGET(urlPDF, headers, "blob").then(response => response.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = id + ".pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      clearInterval(window.timer);
      this.setState({petition: 'PDF',  showModalDownload: false, showModal: false, isLoaded: true, urlPDF: urlPDF, idPedido: id});
    }).catch(error =>{
      console.error(error);
      clearInterval(window.timer);
      this.setState({petition: 'PDF',  showModalDownload: false, showModal: false, isLoaded: true, urlPDF: urlPDF, idPedido: id});
    });
  }

  copyToClipBoard = (str) => {
    const elementToCopy = document.getElementById('urlPDF');
    const selecction = document.createRange();
    selecction.selectNodeContents(elementToCopy);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(selecction);
    document.execCommand('copy');
    window.getSelection().removeRange(selecction);
  }

  handleInputChange = (event) => {

    const target = event.target;
    const value = target.type === 'checkbox'
      ? target.checked
      : target.value;
    const name = target.name;

    this.setState({[name]: value});

  }

  render() {

    const {parentState, conversorPDF} = this.props;//, conversorPNG
    const isTourOpen = this.state.isTourOpen;

    const steps = [
      {
        selector: '.obligatoryFlexBasing',
        content: i18n.t('tour.step3FirstStep'),
      },
      {
        selector: '.map-preview',
        content: i18n.t('tour.step3SecondStep'),
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.description-condiciones',
        content: i18n.t('tour.step3FourthStep'),
      },
      {
        selector: '.download',
        content: i18n.t('tour.step3FifthStep'),
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.step3-paper-type',
        content: i18n.t('tour.step3SixthStep'),
        style: {
          whiteSpace: "pre-line",
          padding: "24px 40px",
        },
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.step3-presentation-type',
        content: i18n.t('tour.step3SeventhStep'),
      },
      parentState.specialMapGeneration ? undefined : {
        selector: '.price',
        content: i18n.t('tour.step3EighthStep'),
      }
    ].filter(Boolean);

    this.loaderAltaRes = i18n.t('step3.loaderAltaRes');
    this.loaderWait = i18n.t('step3.loaderWait');

    //IMAGENES DE LEYENDA
    let legendGroup;
    if(parentState.scale === "1:10.000" || parentState.scale === "1:25.000" || parentState.scale === "1:20.000" || parentState.scale === "1:30.000"){
      legendGroup = [L1_L,L2_L,L3_L,L4_L,L5_L];
    } else if(parentState.scale === "1:40.000" || parentState.scale === "1:50.000" || parentState.scale === "1:60.000"){
      legendGroup = [L1_H,L2_H,L3_H,L4_H,L5_H];
    }

    //Scale to use
    let scaleToShow;
    if(parentState.orientation==='Retrato'){
      switch (parentState.scale) {
        case '1:25.000':
          scaleToShow = E25K_M;break;
        case '1:20.000':
          scaleToShow = E20K_M;break;
        case '1:30.000':
          scaleToShow = E30K_M;break;
        case '1:40.000':
          scaleToShow = E40K_M;break;
        case '1:50.000':
          scaleToShow = E50K_M;break;
        case '1:60.000':
          scaleToShow = E60K_M;break;
        default:
          scaleToShow = E25K_M;
      }
    }else{
      switch (parentState.scale) {
        case '1:25.000':
          scaleToShow = E25K;break;
        case '1:20.000':
          scaleToShow = E20K;break;
        case '1:30.000':
          scaleToShow = E30K;break;
        case '1:40.000':
          scaleToShow = E40K;break;
        case '1:50.000':
          scaleToShow = E50K;break;
        case '1:60.000':
          scaleToShow = E60K;break;
        default:
          scaleToShow = E25K;
      }
    }

    this.classMareografo = this.classMareografo? this.classMareografo : 'mrgrfP';
    if(parentState.mathsDataCenter){
      if(parentState.mathsDataCenter.then){
        parentState.mathsDataCenter.then(()=>{setTimeout(()=>{this.generateMareografo=true;this.setState({})},500);});
      }else{
        if(this.generateMareografo){
          if (parentState.mathsDataCenter[1] !== "undefined") {
            if (parentState.mathsDataCenter[1].includes('Oeste')) {
              if (parentState.mathsDataCenter[3].includes("-")) {
                this.mareografoToShow = ESQM35;
              } else {
                this.mareografoToShow = ESQM38;
              }
            } else {
              if (parentState.mathsDataCenter[3].includes("-")) {
                this.mareografoToShow = ESQM34;
              } else {
                this.mareografoToShow = ESQM37;
              }
            }
          } else {
            this.classMareografo ='mrgrfP smallerMrgrfP';
            if (parentState.mathsDataCenter[3].includes("-")) {
              this.mareografoToShow = ESQM36;
            } else {
              this.mareografoToShow = ESQM39;
            }
          }
          this.setMathsDataCenterToShow = parentState.mathsDataCenter[0];
          this.generateMareografo=false;
        }
      }
    }

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = i18n.t('step1.leftLabelTextTittle');
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = i18n.t('step1.leftLabelDescription');
    const leftBarClassName = 'bar bg-active';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle bg-active';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name active';
    const centerLabelTextTittle = i18n.t('step1.centerLabelTextTittle');
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = i18n.t('step1.centerLabelDescription');
    const rightBarClassName = 'bar bg-active';

    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle bg-active';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name active';
    const rightLabelTextTittle = i18n.t('step1.rightLabelTextTittle');
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = i18n.t('step1.rightLabelDescription');

    //StepBody
    const stepClassName = 'step3'
    const sectionFrontClassName = 's3-left-front';
    const sectionClassName = 's3-left-map';
    const asideClassName = 's3-right';

    //SnackBar
    const snackBarURL = i18n.t('dialog.snackBarURL');
    const snackBarID = i18n.t('dialog.snackBarID');

    //LEGAL TEXT
    let legalText = 'Creado con Mapa a la Carta\nO.A. CENTRO NACIONAL DE INFORMACIÓN GEOGRÁFICA\nGeneral Ibánez de Ibero, 3 - 28003 MADRID\n Teléfono +34 91 597 95 14 \n http://www.cnig.es\n email: consulta@cnig.es';

    const {totalPrice} = this.state;

    return (<LayoutSimple setParentStateSteps={this.setStateGlobal} parentState={parentState} isStep3={1}>
      <Snackbar anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }} onClose={this.handleCloseSnackbar.bind(this)} open={this.state.showSnackbar} autoHideDuration={1500} message={this.state.showSnackbarTypeURL?snackBarURL:snackBarID}/>
      <LoadingModal style={this.state.isLoaded === true ? "none" : true}
        text={this.state.isLoaded === true ? "" : this.state.text} classNameText={this.state.isLoaded === true ? "" : "loadingText"}
        includeLinearProgress={this.state.includeLinearProgress} isFoto={false} />
      <NavigatorSimple leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorSimple>
      <h1>
        <i className="mc-pin-check"></i>
        <label><Trans i18nKey="step3.summary">Resumen</Trans></label>
      </h1>

      <div className={stepClassName}>
      <Dialog open={this.state.showModal} onClose={this.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.generatePDFWarning">
                Está apunto de generar una cartografía en alta resolución en formato PDF. El archivo generado puede llegar a ser pesado, en torno a 150MB. Antes de continuar, considere si su dispositivo o tarifa de datos le permite realizar esta descarga. Este proceso puede durar unos minutos.
              </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleClose}>
                <Trans i18nKey="dialog.close">
                  CERRAR
                </Trans>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={() => this.doRequest(parentState, conversorPDF)}>
                <i className="mc-download"></i>
                <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
      </Dialog>
      <Dialog open={this.state.showModalDownload} onClose={this.handleCloseDownload} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title"><Trans i18nKey="dialog.PDFGenerated">PDF generado</Trans></DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.generatePDFCompleted.Parte1">Su PDF de Mapa a la Carta se ha generado correctamente.</Trans><br/>
            <Trans i18nKey="dialog.generatePDFCompleted.Parte2">Podrá descargarlo ahora o acceder más tarde copiando el siguiente enlace que estará</Trans>&nbsp;
              <b><Trans i18nKey="dialog.generatePDFCompleted.Parte3">disponible durante 7 días:</Trans></b>
              <br/><span id="urlPDF">{this.state.urlPDF}</span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  //this.copyToClipBoard();
                  let urlElement = document.getElementById('urlPDF');
                  if(urlElement && urlElement.innerText){
                    let tempSplit = urlElement.innerText.split("getPDFByID?printID=");
                    if(tempSplit.length === 2 && tempSplit[1].length === 18){
                      navigator.clipboard.writeText(tempSplit[1]);
                      this.handleShowSnackbar(false);
                    }
                  }
                }}>
                <i className="far fa-clipboard"></i>
                <span>&nbsp;<Trans i18nKey="dialog.copyID">COPIAR CÓDIGO</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                  this.copyToClipBoard();
                  this.handleShowSnackbar(true);
                }}>
                <i className="far fa-clipboard"></i>
                <span>&nbsp;<Trans i18nKey="dialog.copyURL">COPIAR ENLACE</Trans></span>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={() => this.downloadPDF(this.state.urlPDF, this.state.idPedido)}>
                <i className="mc-download"></i>
                <label>&nbsp;<Trans i18nKey="dialog.download">DESCARGAR</Trans></label>
              </DialogButton>
            </ThemeProvider>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseDownload}>
              <Trans i18nKey="dialog.close">CERRAR</Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
      </Dialog>
      <Dialog open={this.state.showModalCart && !this.state.showModalRedirect} onClose={this.handleCloseCart} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <ThemeProvider theme={themeTitle}>
          <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.addCart">AÑADIR AL CARRITO</Trans></DialogTitle>
        </ThemeProvider>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="step3.cartConfirmation">Este producto ya está añadido al carrito de la compra ¿quiere añadir más copias o dirigirse al carrito?</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={theme}>
            <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                this.addToShoppingCart(this.state);
              }}>
              <i className="far g-cartografia-mas"></i>
              <span>&nbsp;<Trans i18nKey="step3.add">AÑADIR</Trans></span>
            </DialogButton>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                window.location.href = '/mapaalacarta/ShoppingCart';
              }}>
              <i className="far mc-basket"></i>
              <span>&nbsp;<Trans i18nKey="step3.toCart">IR AL CARRITO</Trans></span>
            </DialogButton>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseCart}>
            <Trans i18nKey="dialog.close">CERRAR</Trans>
            </DialogButton>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
      <Dialog open={this.state.showModalRedirect} onClose={this.handleCloseRedirect} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <ThemeProvider theme={themeTitle}>
          <DialogTitle id="alert-dialog-title"><Trans i18nKey="step3.afterCart">INFORMACIÓN</Trans></DialogTitle>
        </ThemeProvider>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="step3.orderAdded">Pedido añadido al carrito de la compra.</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={theme}>
            <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                window.location.href = '/mapaalacarta/ShoppingCart';
              }}>
              <i className="far mc-basket"></i>
              <span>&nbsp;<Trans i18nKey="step3.toCart">IR AL CARRITO</Trans></span>
            </DialogButton>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <DialogButton style={{ minWidth : "20px" }} size="small" variant="contained" color="primary" onClick={() => {
                window.location.href = '/mapaalacarta';
              }}>
              <i className="far g-cartografia-mas"></i>
              <span>&nbsp;<Trans i18nKey="shoppingCart.addMoreMaps">Añadir más mapas</Trans></span>
            </DialogButton>
          </ThemeProvider>
          <ThemeProvider theme={theme}>
            <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseRedirect}>
            <Trans i18nKey="step3.stayPage">Permanecer en esta página</Trans>
            </DialogButton>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
      <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={this.closeTour} />
      <section className={sectionClassName}>
<figure className='helpClass'>
  <a onClick={this.openTour}>
    <label id="download-tui-image" className="inputfile step3wizardPanelHelpButton">
      <Trans i18nKey="wizardPanel.help">Ayuda</Trans>
    </label>
  </a>
</figure>

<div className="NewPDFPreviewClass PrvwLandCH NewGenAspRatLandscape">
  <div className="PDFPREVIEW3">
    <div className="TITULO">
      <div className='titleSplit'><img className="fullWidthP" alt="Not found" src={LOGO}></img></div>
      <div className='titleMiddle'>
        <div className='titleHeight'>
          <div className="inputTitlePDF">{parentState.title}</div>
          <div className="inputSubTitlePDF cqwMR3">{parentState.subtitle}</div>
        </div>
      </div>
      <div className='titleSplit' align="right"><img className='halfWidthP' alt="Not found" src={this.LOGO_MAC}></img></div>
    </div>
      <div className="PDFPREVIEW6 MAPAASPECTRATIO">
        <table className="mapTableSquare fullWHP">
          <tbody><tr className='TborderHP'>
            <td className='TborderWP'></td>
            <td className='relpos TborderHP mshadowtop'>
              <div className='PDFCoordinatesLeft coordinatesCQW'>{conversorPDF.attributes.xCoordTopLeft}</div>
              <div className='PDFCoordinatesRight coordinatesCQW'>{conversorPDF.attributes.xCoordTopRight}</div>
            </td>
            <td className='TborderWP'></td>
          </tr><tr>
            <td className='TborderWP mshadowleft'>
              <div className='PDFCoordinatesTop coordinatesCQW'>{conversorPDF.attributes.yCoordTopLeft}</div>
              <div className='PDFCoordinatesBottom coordinatesCQW'>{conversorPDF.attributes.yCoordBotLeft}</div>
            </td>
            <td className='relpos2'>
              <MapPreview pluginListPreview={pluginListPreview} setParentState={this.setStateGlobal} parentState={parentState} M={M} centerX={parentState.center[0][0]} centerY={parentState.center[0][1]} mapa={parentState.mapa} scaleValue={parentState.scaleValue} isSimple={false} conversorPDF={conversorPDF}></MapPreview>
            </td>
            <td className='TborderWP mshadowrigth'>
              <div className='PDFCoordinatesTop coordinatesCQW'>{conversorPDF.attributes.yCoordTopRight}</div>
              <div className='PDFCoordinatesBottom coordinatesCQW'>{conversorPDF.attributes.yCoordBotRight}</div>
            </td>
          </tr><tr className='TborderHP'>
            <td className='TborderWP'></td>
            <td className='relpos TborderHP mshadowbottom'>
              <div className='PDFCoordinatesLeft coordinatesCQW'>{conversorPDF.attributes.xCoordBotLeft}</div>
              <div className='PDFCoordinatesRight coordinatesCQW'>{conversorPDF.attributes.xCoordBotRight}</div>
            </td>
            <td className='TborderWP'></td>
          </tr></tbody>
        </table>
      </div>
    <div className="LEYENDA1">
      <div className='bottomLegend lgnd1'><img className="fullWidthP" alt="Not found" src={legendGroup[0]}></img></div>
      <div className='bottomLegend lgnd2'>
        <div className="PtextLH"><div className="cqwMR1">SIGNOS CONVENCIONALES</div><div className="EnglishText cqwMR1"> LEGEND</div></div>
        <div className="PtextLH2"><img className="fullWidthP" alt="Not found" src={legendGroup[1]}></img></div>
      </div>
      <div className='bottomLegend lgnd3'><img className="fullWidthP" alt="Not found" src={legendGroup[2]}></img></div>
      <div className='bottomLegend lgnd4'></div>
      <div className='bottomLegend lgnd5'>
        <div className='cqwMR4'>{parentState.scale}</div>
        <div className='scaleHeight'>
          <img alt="Not found" className="scaleImagePreviewP fullWidthP" src={scaleToShow}></img>
          <div className='cqwMR2 crsTP'>{conversorPDF.attributes.crsText}</div>
          <div>
            <div className='cqwMR2 agrdcP'><div className="cqwMR2 agrdcP2">DATOS PARA EL CENTRO DE LA HOJA</div><br/>{this.setMathsDataCenterToShow}</div>
            <img className={this.classMareografo} alt="Not found" src={this.mareografoToShow}></img>
          </div>
          <div className='cqwMR2 agrdcP3'>{conversorPDF.attributes.agradecimientos}</div>
        </div>
      </div>
      <div className='bottomLegend lgnd6'></div>
      <div className='bottomLegend lgnd7'>
        <div className="PtextLH"><div className="cqwMR1">NÚCLEOS DE POBLACIÓN</div><div className="EnglishText cqwMR1"> POPULATION</div></div>
        <div className="PtextLH2"><img className="fullWidthP" alt="Not found" src={legendGroup[3]}></img></div>
      </div>
      <div className='bottomLegend lgnd8'>
        <div className="PtextLH"><div className="cqwMR1">USOS DEL SUELO</div><div className="EnglishText cqwMR1"> LAND USE</div></div>
        <div className="PtextLH2"><img className="fullWidthP" alt="Not found" src={legendGroup[4]}></img></div>
      </div>
    </div>
  </div>
  <div className={"VERTICAL CARTELA2 obligatoryFlexBasing CHd " + (parentState.specialMapGeneration?"especialMapa ":"") + sectionFrontClassName} style={{position: 'relative'}}>
    <svg xmlns="http://www.w3.org/2000/svg" width="355" height="1650" viewBox="0 0 355 1650" version="1.1" style={{width:"unset", height:"unset"}}>
      <path d="M320 0l35 0 0 1650-115 0 60-507-300 0 0-603 270 0Z" fill={parentState.color}/>
      <rect x="265" y="337" width="30" height="184" fill="#fff"/>
      <rect x="-1" y="845" width="357" height="105" fill="#fff"/>
      <circle cx="83" cy="255" r="40" fill={parentState.color}/>
      <circle cx="83" cy="125" r="40" fill={parentState.color}/>
      <circle cx="228" cy="255" r="40" fill={parentState.color}/>
      <circle cx="228" cy="125" r="40" fill={parentState.color}/>
      <rect x="227" y="576" width="101" height="124" fill="#fff"/>
    </svg>

    <img className='SVGGroup TTCartela' src={TITLETOP} alt='Mapa a la carta, un mapa a tu medida'></img>

    <img className='SVGGroup C4Cartela' src={CIRCLE4} alt='Configura área y escala'></img>
    <p className='SVGGroup C4TCartela'>Configura área y escala</p>
    <img className='SVGGroup C5Cartela' src={CIRCLE5} alt='Leyenda bilingüe'></img>
    <p className='SVGGroup C5TCartela'>Leyenda bilingüe</p>
    <img className='SVGGroup C6Cartela' src={CIRCLE6} alt='Añade tu propia información'></img>
    <p className='SVGGroup C6TCartela'>Añade tu propia información</p>
    <img className='SVGGroup C7Cartela' src={CIRCLE7} alt='Personaliza portada y título'></img>
    <p className='SVGGroup C7TCartela'>Personaliza portada y título</p>

    <img className='SVGGroup ECartela' src={ESPANIA} alt='Mapa de España'></img>
    <p className='SVGGroup IDCartela'>***ID PDF***</p>

    <p className='SVGGroup LTCartela'>{legalText}</p>
    {parentState.specialMapGeneration &&(<img className='SVGGroup CBCartela' src={parentState.realCodigoBarras} alt="*Bar Code*"></img>)}
    <img className='SVGGroup TQRCartela' src={TITLEQR} alt='Mapa a la carta'></img>
    <img className='SVGGroup IQRCartela' src={QRIMAGE} alt='QR Code'></img>
    <p className='SVGGroup TPMCartela'>Crea tu propio mapa</p>

    <p className='SVGGroup CMCartela'>{conversorPDF.attributes.creditosMapa}</p>

    <img className="logo-top-preview" src={this.LOGO_MAC} alt='Logo MAC'></img>
    <img className="degradado-preview" src={DEGRADADO} alt='Degradado'></img>
    <img className="logo-bot-preview" src={LOGO} alt='Logo'></img>
    <p className="front-scale-container-preview">{parentState.scale}</p>
    <p className="front-scale-container-cm-preview">{parentState.scaleCm}</p>
    <p className="front-scale-container-1cm-preview">(1cm ➝</p>
    <div className='img-front-div-preview'>
      <img className='fullWHP' src={parentState.image} alt='Img not found'/>
    </div>
    <p className='front-title-container-preview'>{parentState.title}</p>
    <p className='front-subtitle-container-preview'>{parentState.subtitle}</p>
    <p className='front-author-container-preview'>{parentState.author}</p>
  </div>
</div>
        </section>
        <fieldset>
          {!parentState.specialMapGeneration &&(<legend>
            <div className="description-condiciones condiciones-legend-fieldset">
              <label><input name="condiciones" type="checkbox" checked={this.state.condiciones} onChange={this.handleInputChange}/>
              <label-link>
                <Trans i18nKey="step3.condicionesDeUso.Parte1">
                  Acepto las
                </Trans>&nbsp;
              </label-link>
              <a href={"/" + process.env.REACT_APP_CONTEXT + "condiciones.html"} target="_blank" rel="noopener noreferrer">
                <Trans i18nKey="step3.condicionesDeUso.Parte2">
                  condiciones de uso
                </Trans>
              </a>
              <label-link>
                &nbsp;<Trans i18nKey="step3.condicionesDeUso.Parte3">
                de Mapa a la Carta</Trans></label-link>

              </label>
            </div>
          </legend>)}
          <aside className={asideClassName}>
            <div className="panel-content">

              <h2 className="h2Custom">
                <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
              </h2>
              <div className="description">
                <label><Trans i18nKey="step3.pdfDescription1">Descargar mapa en formato pdf a máxima resolución.</Trans><br/><Trans i18nKey="step3.pdfDescription2">Este proceso puede durar unos minutos.</Trans></label>

              </div>
              <div className="download" style={{ justifyContent : "center" }}>
                {/* MARCAS de doblado */}

                <button className={(!this.state.condiciones && !parentState.specialMapGeneration)
                    ? "buttonDisabled"
                    : ""} onClick={this.handleShow} disabled={!this.state.condiciones && !parentState.specialMapGeneration}>
                  <i className="mc-download"></i>
                  <label><Trans i18nKey="step3.generatePDF">Generar PDF</Trans></label>
                </button>
              </div>
              {!parentState.specialMapGeneration &&(<span>
              <h2 className="h2Custom">
                <label><Trans i18nKey="step3.buyPrint">Adquirir copia impresa</Trans></label>
              </h2>
              <div className="description">
                <label><Trans i18nKey="step3.printDescription">Recibir, por vía postal, un duplicado del mapa que se ha generado.</Trans></label>
              </div>

              <div className="step3-paper-type">
                <h3><label><Trans i18nKey="step3.paperType">Tipo de papel</Trans></label></h3>

                <div className="button-check-row" style={{ justifyContent : "center" }}>
                  <div className="button-check">
                    <button name="Normal" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Normal")
                          ? "mc-normal active fa-2x"
                          : "mc-normal fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.normal">Normal</Trans></label>
                    <i className={this.state.paperType.includes("Normal")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>

                  <div className="button-check">
                    <button name="Aventura" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("Aventura")
                          ? "fas fa-umbrella active fa-2x"
                          : "fas fa-umbrella fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.resistent">Resistente</Trans></label>
                    <i className={this.state.paperType.includes("Aventura")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>
                </div>
              </div>
              <h3><Trans i18nKey="step3.presentation">Presentación</Trans></h3>

              <div className="packaging">
              <div className="step3-presentation-type">
                <div className="button-check-row" style={{ justifyContent : "center" }}>
                  <div className="button-check">
                    <button name="Plegado" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("plegado")
                          ? "mc-map active fa-2x"
                          : "mc-map fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.plegado">Plegado</Trans></label>
                    <i className={this.state.paperType.includes("plegado")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>

                  <div className="button-check">
                    <button name="Enrollado" onClick={this.functionUpdatePrice}>
                      <i style={{
                          pointerEvents: "none"
                        }} className={this.state.paperType.includes("plegar")
                          ? "mc-diploma active fa-2x"
                          : "mc-diploma fa-2x"}></i>
                    </button>
                    <label><Trans i18nKey="step3.paper.liso">Liso</Trans></label>
                    <i className={this.state.paperType.includes("plegar")
                        ? "checked mc-check"
                        : "checked"}></i>
                  </div>
                </div>
                </div>
                <div className="price">
                  <div className='smallPriceMargin'>
                    <input id="priceQuantity" type="number" defaultValue="1" min="1" max="999" onChange={this.functionUpdateCopies} onInput={this.functionUpdateCopies} className="units" style={{
                        width: "45px"
                      }}/>
                    <label className='noWrapClass'>{totalPrice} €</label>
                  </div>
                  <div style={{display:'flex'}}>
                    <button className={!this.state.condiciones
                        ? "buttonDisabled"
                        : ""} name="Compra" onClick={() => this.previuslyAddedToCart[this.state.paperType]?this.handleOpenCart():this.addToShoppingCart(this.state)} disabled={!this.state.condiciones} style={{width:'59%'}}>
                      <i className="mc-basket mc-1x"></i>&nbsp;
                      <label><Trans i18nKey="step3.addCart">AÑADIR AL CARRITO</Trans></label>
                    </button>
                    <button style={{ borderLeft: '2px solid white', width:'41%'}} className={!this.state.condiciones
                        ? "buttonDisabled noWrapClass"
                        : "noWrapClass"} name="Compra" onClick={() => this.tiendaVirtual(this.state)} disabled={!this.state.condiciones}>
                      <i className="far fa-euro-sign"></i>&nbsp;
                      <label><Trans i18nKey="step3.buy">COMPRAR</Trans></label>
                    </button>
                  </div>
                </div>
              </div>
              <div className="description-iva">
                <label><Trans i18nKey="step3.price">Precio sin IVA (envío no incluido)</Trans>
                </label>
                <label>
                <a href="https://www.cnig.es/condicionesCompra" target="_blank" rel="noopener noreferrer">
                    <Trans i18nKey="step3.buyConditions">Condiciones de compra</Trans>
                    </a>
                    <label-link>
                    <Trans i18nKey="step3.virtualShop">de la Tienda Virtual</Trans></label-link>
                </label>
              </div>
              </span>)}
            </div>
          </aside>
        </fieldset>
      </div>

    </LayoutSimple>);
  }
}

export default Step2S;
